import { useEffect, useState } from "react";
import { FaCheck } from "react-icons/fa";
import { Link } from "react-router-dom";
import { FaAngleLeft } from "react-icons/fa6";
import { FaChevronRight } from "react-icons/fa6";
import Header from "../../Common/Header";
import toast, { Toaster } from "react-hot-toast";
import Loader from "../../loader";
import FloatingLabelInput from "../../Common/FloatingLabel";
import { FaInfoCircle } from "react-icons/fa";
import Spinner from "../../Common/Spinner";
import { WillErrors } from "../../api/get";
import { SendMessageToAdmin } from "../../api/api";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal } from "react-responsive-modal";
import { handleApiError } from "../../Common/Helper";
import { useNavigate } from "react-router-dom";
const WillError = () => {
  const [contentLoader, setContentLoader] = useState(true);
  const [ErrorNote, setErrorNote] = useState([]);
  const [Chats, setChats] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ReplyModel, setReplyModel] = useState(false);
  const [refresh, setRefresh] = useState(false); // Track changes
  const navigate = useNavigate();
  useEffect(() => {
    WillErrors()
      .then((res) => {
        if (res.success && res.status_code === "200") {
          setErrorNote(res.data?.admin_notes || []);
          setChats(res.data?.chat || []);
          setContentLoader(false);
        } else {
          handleApiError(res, navigate);
        }
      })
      .catch((err) => {
        console.log(err);
        setContentLoader(false);
      });
  }, [refresh]);
  console.log("Chats", Chats);


  const validationSchema = Yup.object().shape({
    note_title: Yup.string().required("Required field"),
    notes: Yup.string().required("Required field"),
  });
  const Formik = useFormik({
    initialValues: {
      note_title: ErrorNote["note_title"] || "",
      notes: "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values, { resetForm }) => {
      console.log("values =>", values);
      SendMessageToAdmin(values)
        .then((res) => {
          if (res.success && res.status_code === "200") {
            toast.success("Notes Send Successfully");
            resetForm(); // This will clear the form fields
            setRefresh((prev) => !prev);
            setReplyModel(false);
          } else {
            handleApiError(res, navigate);
          }
        })
        .catch((err) => {
          setLoading(false);
          toast.error("An error occurred");
          console.log(err);
        });
    },
  });
  const onCloseModel = () => {
    setReplyModel(false);
    Formik.resetForm(); // Reset the form on modal close
  };
  return (
    <>
      {contentLoader ? (
        <Loader />
      ) : (
        <>
          <Toaster />
          <Header />
          <div className="container mx-auto p-5">
            <div className="grid grid-cols-1 max-lg:grid-cols-1">
              {/* Left Section */}
              <div>
                <div>
                  <p className="text-[22px] sm:text-[24px] md:text-[26px] lg:text-[30px] font-semibold mb-1">
                    We've spotted a few things...
                  </p>
                </div>
                <div className="text-[16px] leading-relaxed">
                  One of Our expert has found a few things that need your
                  attention.
                </div>
                <div className="text-[16px] leading-relaxed">
                  in some cases, you'ii want to go back to your will to make
                  sure you’ve got everything right.
                </div>
                <div className="text-[16px] leading-relaxed">
                  Sometimes,we might just need a bit more information from you
                  to make sure we've fully explained how your will works.
                </div>
                <div className="my-5">
                  <div>
                    <p className="text-[22px] sm:text-[24px] md:text-[26px] lg:text-[30px] font-semibold mb-1">
                      {ErrorNote["note_title"] &&
                        ErrorNote["note_title"].charAt(0).toUpperCase() +
                          ErrorNote["note_title"].slice(1)}
                    </p>
                  </div>
                  <div
                    className="text-[16px] leading-relaxed"
                    dangerouslySetInnerHTML={{ __html: ErrorNote["notes"] }}
                  ></div>
                </div>
                <div>
                  <div className="pt-5 flex justify-between items-center">
                    <div className="flex pb-5">
                      <Link to={"/dashboard"}>
                        <button className="flex items-center justify-center gap-1 font-semibold text-[16px] py-2 rounded-[5px] text-slate-500 bg-primary text-white p-5">
                          Edit Will
                        </button>
                      </Link>
                    </div>
                    <div className="flex  pb-5">
                      <button
                        className="text-[16px] px-5 py-2 font-muli font-semibold rounded-[5px] flex items-center gap-1 border border-black hover:bg-primary hover:text-white"
                        onClick={() => setReplyModel(true)}
                      >
                        Edit reply
                      </button>
                    </div>
                  </div>
                </div>
                <div className="overflow-x-auto lg:overflow-x-visible">
                  <h2 className="text-[22px] text-black font-bold mb-4">
                    Message History:
                  </h2>
                  <div className="space-y-4">
                    {Chats.map((chat, index) => (
                      <div
                        key={index}
                        className={`flex flex-wrap justify-between border border-gray-200 bg-white p-4 rounded-lg shadow-sm hover:shadow-md ${
                          chat.type === "Admin" ? "admin-div-bg" : "user-div-bg"
                        }`}
                      >
                        {/* Left Side: Note Title and Notes */}
                        <div className="w-full lg:w-[70%]">
                          <div className="text-[16px] md:text-[18px] lg:text-[18px] font-bold mb-1">
                            {chat.note_title &&
                              chat.note_title.charAt(0).toUpperCase() +
                                chat.note_title.slice(1)}
                          </div>
                          <div className="text-[16px] font-bold mb-1">
                            Notes:
                          </div>
                          <div
                            className="text-base text-gray-600 leading-relaxed mb-2"
                            dangerouslySetInnerHTML={{
                              __html: chat.notes,
                            }}
                          ></div>
                        </div>

                        {/* Right Side: Sender Type and Time */}
                        <div className="w-full lg:w-[26%] lg:text-right">
                          <div className="text-sm font-bold mb-1">
                            Sender : {chat.type}
                          </div>
                          <div className="text-sm font-bold mb-1">
                            Date & Time :{" "}
                            {chat.timestamp
                              ? new Date(chat.timestamp).toLocaleString(
                                  "en-GB",
                                  {
                                    day: "2-digit",
                                    month: "2-digit",
                                    year: "numeric",
                                    hour: "2-digit",
                                    minute: "2-digit",
                                    second: "2-digit",
                                    hour12: true,
                                  }
                                )
                              : "N/A"}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="border-b-2 my-5"></div>
              </div>

              {/* Right Section */}
              {/* <div>
                <div className="max-lg:hidden bg-no-repeat">
                  <div className="fixed top-[100px] w-[500px] right-[6%]">
                    <img src="/assets/images/10.png" alt="mascot" />
                  </div>
                </div>
              </div> */}

              <Modal
                open={ReplyModel}
                onClose={onCloseModel}
                center
                classNames={{
                  modal:
                    "rounded-[5px] p-5 w-[90%] sm:w-[75%] md:w-[60%] lg:w-[45%] xl:w-[35%] mx-auto", // Adjust modal width for different screen sizes
                }}
              >
                <form onSubmit={Formik.handleSubmit} className="mx-5">
                  <div>
                    <h2 className="font-bold text-[22px] md:text-[24px] mb-2">
                      {ErrorNote["note_title"] &&
                        ErrorNote["note_title"].charAt(0).toUpperCase() +
                          ErrorNote["note_title"].slice(1)}
                      <input
                        type="hidden"
                        name="note_title"
                        value={Formik.values.note_title}
                      />
                    </h2>
                    <h2 className="font-bold text-[18px] mb-2">
                      Add your reply
                    </h2>
                    <p>
                      Our Will Experts will see your message and can then advice
                      you on how to proceed.
                    </p>
                    <div className="w-full mt-4">
                      {/* <label
                        htmlFor="notes"
                        className="block text-sm font-medium text-gray-700"
                      >
                        Add your reply here...
                      </label> */}
                      <textarea
                        id="notes"
                        name="notes"
                        placeholder="Add your reply here..."
                        className="w-full border border-gray-300 rounded-[5px] p-3 text-black focus:outline-none focus:ring-2 focus:ring-primary"
                        rows="4"
                        value={Formik.values.notes || ""}
                        onChange={Formik.handleChange}
                        onBlur={Formik.handleBlur}
                      />
                      {Formik.touched.notes && Formik.errors.notes && (
                        <div className="bg-[#f44336] text-white flex items-center gap-2 px-5 rounded-b-lg">
                          <FaInfoCircle />
                          <p className="text-white py-1 px-2 text-sm my-2">
                            {Formik.errors.notes}
                          </p>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="flex flex-col md:flex-row justify-between items-center gap-5 py-5">
                    <div className="w-full md:w-[50%]">
                      <button
                        type="submit"
                        className="w-full bg-primary px-5 py-3 text-white font-muli font-semibold rounded-[5px] flex justify-center items-center gap-2"
                      >
                        Reply
                      </button>
                    </div>
                  </div>
                </form>
              </Modal>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default WillError;
